import { render, staticRenderFns } from "./OnlCgformAutoList.vue?vue&type=template&id=28818424&scoped=true&"
import script from "./OnlCgformAutoList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformAutoList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformAutoList.vue?vue&type=style&index=0&id=28818424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28818424",
  null
  
)

export default component.exports